// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';
import { getToken } from '@/utils/auth';

/**
 * @description 身份管理 -- 列表
 */
export function menuRoleApi(data: any) {
    return request({
        url: 'system/role/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 身份管理 -- 新增
 */
export function roleCreateApi(query?: Record<string, unknown>) {
    return request({
        url: 'system/role/create/form',
        method: 'get',
        params: query,
    });
}

/**
 * @description 身份管理 -- 编辑
 */
export function roleUpdateApi(id: number | string, query?: Record<string, unknown>) {
    return request({
        url: `system/role/update/form/${id}`,
        method: 'get',
        params: query,
    });
}

/**
 * @description 身份管理 -- 删除
 */
export function roleDeleteApi(id: number | string) {
    return request({
        url: `system/role/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 身份管理 -- 修改状态
 */
export function roleStatusApi(id: number | string, status: number) {
    return request({
        url: `system/role/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 管理员 -- 列表
 */
export function adminListApi(data: any) {
    return request({
        url: 'system/admin/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 管理员 -- 新增
 */
export function adminCreateApi(query?:any) {
    return request({
        url: '/system/admin/create/form',
        method: 'get',
        params: query,
    });
}

/**
 * @description 管理员 -- 编辑
 */
export function adminUpdateApi(id: number | string, query?:any) {
    return request({
        url: `system/admin/update/form/${id}`,
        method: 'get',
        params: query,
    });
}

/**
 * @description 管理员 -- 删除
 */
export function adminDeleteApi(id: number | string) {
    return request({
        url: `system/admin/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 管理员 -- 修改状态
 */
export function adminStatusApi(id: number | string, status: number) {
    return request({
        url: `system/admin/status/${id}`,
        method: 'post',
        data: { status },
    });
}

/**
 * @description 管理员 -- 修改密码表单
 */
export function adminPasswordApi(id: number | string) {
    return request({
        url: `system/admin/password/form/${id}`,
        method: 'get',
    });
}

/**
 * @description 操作日志 -- 列表
 */
export function adminLogApi(data: any) {
    return request({
        url: 'system/admin/log',
        method: 'get',
        params: data,
    });
}

/**
 * @description 一号通 -- 是否登录
 */
export function isLoginApi() {
    return request({
        url: 'serve/user/is_login',
        method: 'get',
    });
}

/**
 * @description 一号通 -- 用户信息
 */
export function serveInfoApi() {
    return request({
        url: 'serve/user/info',
        method: 'get',
    });
}

/**
 * @description 一号通 -- 是否登录
 */
export function smsPriceApi(type: string) {
    return request({
        url: `serve/mealList/${type}`,
        method: 'get',
    });
}

/**
 * @description 一号通短信账户 -- 退出登录
 */
export function logoutApi() {
    return request({
        url: 'sms/logout',
        method: 'get',
    });
}

/**
 * @description 一号通短信账户 -- 登录
 */
export function configApi(data: any) {
    return request({
        url: 'serve/login',
        method: 'post',
        data,
    });
}

/**
 * @description 一号通短信账户 -- 支付二维码
 */
export function payCodeApi(data: any) {
    return request({
        url: 'serve/paymeal',
        method: 'get',
        params: data,
    });
}

/**
 * @description 一号通短信账户 -- 列表
 */
export function smsRecordApi(data: any) {
    return request({
        url: 'sms/record',
        method: 'get',
        params: data,
    });
}

/**
 * @description 一号通短信账户 -- 列表
 */
export function serveRecordListApi(data: any) {
    return request({
        url: 'serve/record',
        method: 'get',
        params: data,
    });
}

/**
 * @description 一号通短信账户 -- 物流列表
 */
export function serveQueryListApi(data: any) {
    return request({
        url: 'serve/us_lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 一号通 -- 开通服务
 */
export function serveOpen(data: any) {
    return request({
        url: 'serve/open',
        method: 'post',
        data,
    });
}

/**
 * @description 一号通 -- 快递列表
 */
export function exportAllApi() {
    return request({
        url: 'serve/expr/lst',
        method: 'get',
    });
}

/**
 * @description 一号通 -- 开通服务
 */
export function exportTempApi(data: any) {
    return request({
        url: 'serve/expr/temps',
        method: 'get',
        params: data,
    });
}

/**
 * @description 短信账户签名修改 -- 获取验证码
 */
export function captchaApi(phone: string) {
    return request({
        url: `serve/captcha/${phone}`,
        method: 'get',
    });
}

/**
 * @description 短信账户签名修改 -- 确认修改
 */
export function serveSign(data: any) {
    return request({
        url: 'serve/change_sign',
        method: 'post',
        data,
    });
}

/**
 * @description 短信账户签名修改 -- 检查验证码
 */
export function checkCaptchaApi(data: any) {
    return request({
        url: 'serve/captcha',
        method: 'post',
        data,
    });
}

/**
 * @description 一号通 -- 修改密码
 */
export function serveModifyApi(data: any) {
    return request({
        url: 'serve/change_password',
        method: 'post',
        data,
    });
}

/**
 * @description 一号通 -- 修改手机号
 */
export function updateHoneApi(data: any) {
    return request({
        url: 'serve/change_phone',
        method: 'post',
        data,
    });
}

/**
 * @description 一号通 -- 获取配置信息
 */
export function getSmsConfig() {
    return request({
        url: 'serve/config',
        method: 'get',
    });
}

/**
 * @description 一号通 -- 更新配置信息
 */
export function updateSmsConfig(data: any) {
    return request({
        url: 'serve/config',
        method: 'post',
        data,
    });
}

/**
 * @description 服务设置 -- 添加设置
 */
export function addServiceConfig() {
    return request({
        url: 'serve/meal/create/form',
        method: 'get',
    });
}

/**
 * @description 服务设置 -- 列表
 */
export function aserviceConfigLst(data: any) {
    return request({
        url: 'serve/meal/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 服务设置 -- 是否显示
 */
export function aserviceStatusApi(id: number | string, data: any) {
    return request({
        url: `serve/meal/status/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 服务设置 -- 编辑
 */
export function updateServiceConfig(id: number | string) {
    return request({
        url: `serve/meal/update/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 服务设置 -- 删除
 */
export function deleteServiceConfig(id: number | string) {
    return request({
        url: `serve/meal/detele/${id}`,
        method: 'delete',
    });
}

/**
 * @description 平台购买记录 -- 列表
 */
export function purchaseRecordLst(data: any) {
    return request({
        url: 'serve/paylst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 商户购买记录 -- 列表
 */
export function purchaseMerLst(data: any) {
    return request({
        url: 'serve/mer/paylst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 商户结余记录 -- 列表
 */
export function merBalanceLst(data: any) {
    return request({
        url: 'serve/mer/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 消息管理 -- 列表
 */
export function messageManageLst(data: any) {
    return request({
        url: 'notice/config/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 消息管理 -- 添加消息
 */
export function addMessageApi() {
    return request({
        url: 'notice/config/create/form',
        method: 'get',
    });
}

/**
 * @description 消息管理 -- 设置
 */
export function messageSettingApi(id: number | string) {
    return request({
        url: `notice/config/update/${id}/form`,
        method: 'get',
    });
}

export function messageChangeApi(id: number | string) {
    return request({
        url: `notice/config/change/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 消息管理 -- 是否显示
 */
export function messageStatusApi(id: number | string, data: any) {
    return request({
        url: `notice/config/status/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 消息管理 -- 同步小程序订阅消息
 */
export function syncAppletsApi() {
    return request({
        url: 'wechat/template/min/sync',
        method: 'get',
        // 对齐 EB view/admin request.js 默认 60s；逐条请求微信关键词/添加模板，10s 必超时
        timeout: 60000,
    });
}

/**
 * @description 消息管理 -- 同步公众号订阅消息
 */
export function syncPublicApi() {
    return request({
        url: 'wechat/template/sync',
        method: 'get',
        // 对齐 EB view/admin request.js 默认 60s；会先删公众号已有模板再逐条添加
        timeout: 60000,
    });
}

/**
 * @description 一键换色 -- 获取
 */
export function getStyleApi() {
    return request({
        url: 'change/color',
        method: 'get',
    });
}

/**
 * @description 一键换色 -- 提交
 */
export function setStyleApi(data: any) {
    return request({
        url: 'change/color',
        method: 'post',
        data,
    });
}

/**
 * @description 协议与规则 -- 左侧获取列表
 */
export function keylstApi() {
    return request({
        url: 'agreement/keylst',
        method: 'get',
    });
}

/**
 * @description 协议与规则 -- 获取对应的数据
 */
export function getAgreeApi(key: string) {
    return request({
        url: `agreement/${key}`,
        method: 'get',
    });
}

/**
 * @description 协议与规则 -- 编辑对应的数据
 */
export function postAgreeApi(key: string, data: any) {
    return request({
        url: `agreement/${key}`,
        method: 'post',
        data,
    });
}

/**
 * @description 扫码上传链接获取
 */
export function scanUploadQrcode(pid: number | string) {
    return request({
        url: `system/attachment/scan_upload/qrcode/${pid}`,
        method: 'get',
    });
}

/**
 * @description 扫码上传获取图片
 */
export function scanUploadGet(scanToken: string) {
    return request({
        url: `system/attachment/scan_upload/image/${scanToken}`,
        method: 'get',
    });
}

/**
 * @description 扫码上传提交
 */
export function scanUploadSave(scanToken: string, data: any) {
    return request({
        url: `system/attachment/scan_upload/image/${scanToken}`,
        method: 'post',
        data,
    });
}

/**
 * @description 扫码上传提交数据
 */
export function fileUpload(id: number | string, field: any) {
    return request({
        url: `upload/image/${id}/file`,
        method: 'post',
        data: field,
        headers: {
            repeatSubmit: false,
        },
    });
}

/**
 * @description 网络上传提交数据
 */
export function onlineUpload(data: any) {
    return request({
        url: 'system/attachment/online_upload',
        method: 'post',
        data,
    });
}

/**
 * @description 系统表单--添加
 */
export function systemForm(data: any) {
    return request({
        url: 'system/form/create',
        method: 'post',
        data,
    });
}

/**
 * @description 系统表单--详情
 */
export function systemFormInfo(id: number | string) {
    return request({
        url: `system/form/detail/${id}`,
        method: 'get',
    });
}

/**
 * @description 系统表单--编辑
 */
export function systemFormUpdate(id: number | string, data: any) {
    return request({
        url: `system/form/update/${id}`,
        method: 'post',
        data,
    });
}

/**
 * @description 系统表单--列表
 */
export function systemFormList(data: any) {
    return request({
        url: 'system/form/lst',
        method: 'get',
        params: data,
    });
}

/**
 * @description 系统表单--删除
 */
export function formDeleteApi(id: number | string) {
    return request({
        url: `system/form/delete/${id}`,
        method: 'delete',
    });
}

/**
 * @description 系统表单--详情
 */
export function formDetailList(id: number | string, data: any) {
    return request({
        url: `system/form/user_lst/${id}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 系统表单--详情导出
 */
export function formDetailExcel(data: any) {
    return request({
        url: 'system/form/excel',
        method: 'get',
        params: data,
    });
}

/**
 * @description 储存管理--存储配置
 */
export function storageConfigApi() {
    return request({
        url: 'system/storage/config',
        method: 'get',
    });
}

/**
 * @description 储存管理--存储方式
 */
export function storageTypeApi() {
    return request({
        url: 'system/storage/type_list',
        method: 'get',
    });
}

/**
 * @description 储存管理--获取key
 */
export function getStorageKeyApi(type: number) {
    return request({
        url: `system/storage/${type}/form`,
        method: 'get',
    });
}

/**
 * @description 储存管理--存储空间列表
 */
export function storageListApi(type: number, data: any) {
    return request({
        url: `system/storage/region/lst/${type}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 储存管理--存储空间列表
 */
export function addConfigApi(type: number, data: any) {
    return request({
        url: `system/storage/region/lst/${type}`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 储存管理--保存
 */
export function positionPostApi(data: any) {
    return request({
        url: 'system/storage/config',
        method: 'post',
        data,
    });
}

/**
 * @description 储存管理--同步存储空间
 */
export function storageSynchApi(type: number) {
    return request({
        url: `system/storage/sync/${type}`,
        method: 'get',
    });
}

/**
 * @description 储存管理--添加存储空间
 */
export function addStorageApi(type: number) {
    return request({
        url: `system/storage/region/create/${type}/form`,
        method: 'get',
    });
}

/**
 * @description 储存管理--修改空间域名
 */
export function editStorageApi(id: number | string) {
    return request({
        url: `system/storage/domain/update/${id}/form`,
        method: 'get',
    });
}

/**
 * @description 储存管理--修改空间状态
 */
export function storageStatusApi(id: number | string) {
    return request({
        url: `system/storage/region/status/${id}`,
        method: 'post',
    });
}

/**
 * @description 储存管理--删除存储空间
 */
export function storageDeleteForm(id: number | string) {
    return request({
        url: `system/storage/region/delete/${id}`,
        method: 'delete',
    });
}



// eb 缺失添加

/**
* @description 设置 短信设置 列表
* @param {Object} param params {Object} 传值参数
*/
export function tempListApi(params:any) {
    return request({
        url: params.url,
        method: 'get',
        params: params.data,
    });
}

/**
* @description 设置 短信设置 申请模板表单
* @param {Object} param data {Object} 传值参数 type类型
*/
export function tempCreateApi() {
    return request({
        url: 'notify/sms/temp/create',
        method: 'get',
    });
}


/** 短信模板列表 / 申请模板表单（复用 @/api/setting/setting 实现） */

